<template>
  <div ref="page" class="pwc-question-form" :style="cFormStyle">
    <pwc-container class="pwc-app-container">
      <div class="pwc-logo">
        <img src="../../../assets/logo.png">
      </div>
      <v-img v-if="!submited && !data.isLargeImage" contain class="pwc-form-title" :src="data.Image" width="100%" height='200px'/>
      <template v-if="!submited &&  data.isLargeImage">
          <div v-for="(item,index) in data.Images" :key="index">
           <v-img  contain class="pwc-form-title" :src="item" width="100%" />
          </div>
      </template>
      <div v-if="!submited" class="pwc-form-title">
        <span>{{ data.Title }}</span>
      </div>
      <div v-if="!submited && data.Description" class="pwc-form-desc">
        <!-- eslint-disable-next-line -->
        <span v-html="data.Description.replace(/\n/gm, '<br/>')" />
      </div>
      <DyForm v-if="!submited" ref="dyform" :data="data" :surveyType="surveyType" :surveyId="surveyId" @applyStatus="getApplyStatus" @submited="getSubmited"  :delay="!needLogin" :form-data="formData" :file-keys="fileKeys" @submitForm="(val) => {submitForm(val)}" />
      <div v-else class="success-wrap">
        <success-page ref="success" :data="data" :applyStatus="applyStatus" :advanced="showAdvancedThanksPage" :attachment="successAttachment" />
      </div>
      <!-- <div class="pwc-form-privacy">
        <span>
          <a href="https://youplusapplication.businesstrainingshpwc.com/application/TermsOfUse.html">&nbsp;使用条款&nbsp;</a>和
          <a href="https://youplusapplication.businesstrainingshpwc.com/application/PrivacyStatement.html">&nbsp;隐私条款</a></span>
      </div> -->
    </pwc-container>
    <v-dialog v-if="showVerifyDialog" v-model="showVerifyDialog" max-width="320" persistent>
      <v-card>
        <v-form ref="verifyform" class="pwc-dialog-submit">
          <pwc-phone :phone.sync="verification.phoneNo" :code.sync="verification.contryCode" :surveyType="surveyType" :surveyId="surveyId"  @FromPhoneCApplyStatus="FromPhoneCApplyStatus" @FromPhoneCSubmited="FromPhoneCSubmited"  @getShowVerifyDialog="getShowVerifyDialog" @applyStatus="getApplyStatus"  @submited="getSubmited"/>
          <pwc-phone-verify :resendable="validatePhone()" :verify-code="handleGetVerifyCode" :code.sync="verification.verificationCode" />
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn :disabled="loading.saveNewSurveyAnswerLoading" color="#d04a02" flat="flat" @click="handleVerifyDialogCancel">取消</v-btn>
          <v-btn color="#d04a02" flat="flat" :loading="loading.saveNewSurveyAnswerLoading" @click="handleVerifyDialogConfirm">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-if="showCaptchaDialog" v-model="showCaptchaDialog" max-width="320" persistent>
      <v-card>
        <v-form ref="captchform" class="pwc-dialog-submit">
          <v-layout row>
            <v-flex>
              <!-- <v-text-field v-model="captchaObj.answer" validate-on-blur single-line :maxlength="4" label="验证码" required clearable :rules="[rules.required]" /> -->
              <v-text-field v-model="captchaObj.answer" validate-on-blur single-line :maxlength="4" label="验证码" mask="######" required clearable clear-icon="fas fa-times" :rules="[rules.required, rules.captcha]" />

            </v-flex>
            <v-flex>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div class="captcha-img"><v-img width="86" height="40" :src="captchaObj.image" v-on="on" @click="GetCaptcha" /></div>
                </template>
                <span>点击重新获取验证码</span>
              </v-tooltip>
            </v-flex>
          </v-layout>
        </v-form>
        <v-card-actions>
          <v-spacer />
          <v-btn :disabled="loading.saveAnonymousSurveyAnswerLoading" color="#d04a02" flat="flat" @click="closeAnonymousSurveyAnswer">取消</v-btn>
          <v-btn color="#d04a02" flat="flat" :loading="loading.saveAnonymousSurveyAnswerLoading" @click="submitAnonymousSurveyAnswer">确定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-if="showWechatPublicAccountQr"
      v-model="showWechatPublicAccountQr"
      max-width="320"
      persistent
    >
      <v-card>
        <div class="public-qr-title">
          <p>微信扫码 关注公众号报名</p>
        </div>
        <img class="public-qr-code" :src="ypPublicQr" alt="" srcset="">
        <v-card-actions>
          <v-spacer />
          <v-btn color="#d04a02" flat="flat" @click="showWechatPublicAccountQr=false">我知道了</v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import PwcContainer from '@/views/layout/desktop/PwcContainer'
import DyForm from '@/components/PwcDyForm/desktop'
import SuccessPage from '@/views/survey/common/success'
import { common } from '../common/mixin.js'
import Detect from '@/util/detect'
const isMobile = Detect(window.navigator.userAgent).mobile()
import { validRequired, captchaCode, validPhone, validOtherPhone } from '@/util/validation'
import ypPublicQr from '@/assets/yp-public-qrcode.png'

export default {
  name: 'Survey',
  components: {
    PwcContainer,
    DyForm,
    SuccessPage
  },
  mixins: [common],
  data() {
    return {
      rules: {
        required: validRequired,
        captcha: captchaCode
      },
      showWechatPublicAccountQr: false,
      ypPublicQr
    }
  },
  computed: {
    cFormStyle() {
      if (isMobile) {
        return {
          'background-image': 'none'
        }
      }
      return {}
    }
    // cThankslogoStyle() {
    //   if (!isMobile && this.submited) {
    //     return {
    //       'background-color': 'transparent'
    //     }
    //   }
    //   return {}
    // }
  },
  methods: {
    validPhone,
    validOtherPhone,
    validatePhone() {
      // eslint-disable-next-line eqeqeq
      if (this.verification.contryCode == 86) {
        return this.validPhone(this.verification.phoneNo)
        // eslint-disable-next-line eqeqeq
      } else if (this.verification.contryCode != 86) {
        return this.validOtherPhone(this.verification.phoneNo)
      }
    },
    getSubmited(val){
      this.submited = val
    },
    getApplyStatus(val){
      this.applyStatus = val
    },
    FromPhoneCApplyStatus(val){
      this.applyStatus = val
    },
    FromPhoneCSubmited(val){
      this.submited = val
    },
    getShowVerifyDialog(val){
      this.showVerifyDialog = val
    }
  }
}
</script>
<style lang="scss">
.pwc-question-form {
  font-family: 'Microsoft YaHei', Georgia, "Times New Roman", Times, serif;
  // overflow-y: auto;
  // background-image: url("../../../assets/register-form-bg.jpg");
  background-image: url("../../../assets/self-diagnosis-bg.jpg");
  background-attachment: fixed;
  min-height: 100vh;
  .pwc-app-container {
    margin-bottom: 0;
    margin-top: 0;
    padding-top: 36px;
    padding-bottom: 36px;
  }

  .pwc-form-title,
  .pwc-form-desc,
  .pwc-form-data,
  .pwc-form-action {
    margin: auto;
    max-width: 640px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: #fff;
    padding-top: 24px;
  }

  .pwc-form-title {
    text-align: center;
    font-size: 18px;
    font-weight: normal;
    padding-top: 40px;
    padding-bottom: 20px;
  }

  .pwc-form-desc {
    text-align: left;
    font-size: 14px;
    font-weight: normal;
    line-height: 20px;
  }

  .pwc-form-action {
    text-align: center;
    padding-bottom: 32px;
  }
}

.pwc-logo {
  margin: auto;
  box-sizing: border-box;
  position: relative;
  height: auto;
  width: auto;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  max-width: 640px;
  padding-top: 36px;
  padding-bottom: 40px;
  img {
    width: 400px;
  }
}

.pwc-dialog-submit {
  padding: 22px;
  padding-top: 36px;
  padding-bottom: 6px;
}

.pwc-form-privacy {
  text-align: center;
  font-size: 16px;
  padding-top: 30px;
  padding-bottom: 15px;
  background-color: #fff;
  max-width: 640px;
  margin: auto;
  height: auto;
  width: auto;
  overflow: hidden;
}

.public-qr-code {
    user-select: none;
    display: block;
    width: 160px;
    height: 160px;
    margin: auto;
}
.public-qr-title {
  user-select: none;
  padding: 16px;
  text-align: center;
  p {
    margin: 0;
    font-weight: bold;
    font-size: 16px;
  }
}

@media all and (max-width: 960px) {
  .pwc-logo {
    margin: auto;
    box-sizing: border-box;
    position: relative;
    height: auto;
    width: auto;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    img {
      width: 300px;
    }
  }
}
</style>
<style lang="scss">
.pwc-question-form {
  .theme--light.v-text-field.v-input--is-disabled
    > .v-input__control
    > .v-input__slot:before {
    border-image: none;
  }

  .v-text-field--box > .v-input__control > .v-input__slot {
    border-radius: 0;
  }

  .v-input--radio-group__input {
    .v-input--selection-controls {
      margin-top: 0;
    }

    .v-input__slot {
      margin-bottom: 4px;
    }

    .v-messages {
      display: none;
    }
  }
}
.success-wrap {
  margin: 0 auto;
  max-width: 640px;
  min-height: calc(100vh - 200px);
  padding: 40px 50px 40px;
  background-color: #fff;
  text-align: left;
}
.captcha-img {
  margin-top: 10px;
  margin-left: 10px;
  cursor: pointer;
}
</style>
